//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      // markerPos: { lat: null, lng: null },
      address: null,
      longitude: null,
      latitude: null,
      longitudeField: null,
      latitudeField: null,
      zoomField: null,
      longitudeView: null,
      latitudeView: null,
      zoomView: null,
      labelWidth: 0
    };
  },
  computed: {
    markerPos: function markerPos() {
      return {
        lat: this.latitude || 0,
        lng: this.longitude || 0
      };
    },
    mapStyles: function mapStyles() {
      return this.longitude != null && this.latitude != null ? {
        display: "block"
      } : {
        display: "none"
      };
    }
  },
  methods: {
    $ready: function $ready() {
      var _this = this;

      this.address = this.spec.value;
      this.longitudeField = this.spec.longitudeField;
      this.latitudeField = this.spec.latitudeField;
      this.zoomField = this.spec.zoomField;
      this.centerInitial();
      setTimeout(function () {
        _this.latitudeView = _this.$refs.latitudeView.$children[0];
        _this.longitudeView = _this.$refs.longitudeView.$children[0];

        if (_this.$refs.zoomView) {
          _this.zoomView = _this.$refs.zoomView.$children[0];
        }

        var labelView = _this.$refs.label;
        _this.labelWidth = labelView.getBoundingClientRect().width + 6;
      });
    },
    centerInitial: function centerInitial() {
      var latitudeValue = Utils.type.floatValue(this.latitudeField.value);
      var longitudeValue = Utils.type.floatValue(this.longitudeField.value);

      if (latitudeValue !== 0 && longitudeValue !== 0) {
        this.setLocation(latitudeValue, longitudeValue, true); // Avoid asking for user location right away for now
        // } else {
        //   navigator.geolocation.getCurrentPosition(position => {
        //     const coordinate = position.coords;
        //     this.setLocation(coordinate.latitude, coordinate.longitude, false);
        //   });
      }
    },
    setLocation: function setLocation(latitudeValue, longitudeValue, dropPin) {
      var _this2 = this;

      this.$refs.map.$gmapApiPromiseLazy().then(function () {
        // eslint-disable-next-line no-undef
        var location = new google.maps.LatLng(latitudeValue, longitudeValue);

        _this2.$refs.map.$mapObject.setCenter(location);

        if (dropPin) {
          _this2.setMarkerPosition(location);
        }
      });
    },
    setMarkerPosition: function setMarkerPosition(location) {
      this.latitude = location.lat();
      this.longitude = location.lng();
      this.latitudeView.fieldModel = location.lat();
      this.longitudeView.fieldModel = location.lng();
    },
    onPlaceChanged: function onPlaceChanged(place) {
      this.address = place.formatted_address;
      var location = place.geometry.location;
      this.setMarkerPosition(location);
      this.$refs.map.$mapObject.setCenter(location);
    },
    onDrag: function onDrag(e) {
      this.setMarkerPosition(e.latLng);
    },
    onActionCompleted: function onActionCompleted() {
      if (this.zoomView) {
        this.zoomView.fieldModel = this.$refs.map.$mapObject.zoom;
      }
    },
    onAddressChanged: function onAddressChanged(e) {
      this.address = e.target.value;

      if (this.address === "") {
        this.address = null;
        this.longitude = null;
        this.latitude = null;
        this.latitudeView.fieldModel = null;
        this.longitudeView.fieldModel = null;
      }
    },
    // Override
    $displayValue: function $displayValue() {
      return "block";
    }
  }
};